import React, { useEffect } from "react";
import {NumericFormat} from "react-number-format";

function InvoiceBidCalculation({ totalCharges, currencySelected }) {
  // For !== "JPY" slice no after 2 dec
  // For === "JPY" round of for 0 dec
  const contractedCharges =
    currencySelected?.currCode !== "JPY"
      ? totalCharges["totalContractedCharges"]
      : parseFloat(totalCharges["totalContractedCharges"]).toFixed(0);
  const nonContractedCharges =
    currencySelected?.currCode !== "JPY"
      ? totalCharges["totalNonContractedCharges"]
      : parseFloat(totalCharges["totalNonContractedCharges"]).toFixed(0);
  const _totalCharges =
    currencySelected?.currCode !== "JPY"
      ? totalCharges["totalQuotationCharges"]
      : parseFloat(totalCharges["totalQuotationCharges"]).toFixed(0);

  return (
    <>
      <div className="billdetails-calculation">
        <div className="total-contracted-charges">
          <label>
            Total Contracted Charges:{" "}
            <span className="small">
              (Submit an additional/separate Invoice to CTSI using contracted
              Service Level Code)
              {/* (Invoice separately Contracted ‘Y’ Fee code charges) */}
            </span>
          </label>
          <div className="calculation-input">
            <NumericFormat
              thousandSeparator={true}
              className="some"
              inputmode="numeric"
              value={Number(contractedCharges)}
              disabled
              decimalSeparator={currencySelected?.currCode !== "JPY" ? "." : ""}
              decimalScale={currencySelected?.currCode !== "JPY" ? "2" : "0"}
              fixedDecimalScale={
                currencySelected?.currCode !== "JPY" ? "true" : "false"
              }
            />
            {/* <input
              type="text"
              disabled
              value={totalCharges["totalContractedCharges"]}
            /> */}
          </div>
        </div>
        <div className="total-contracted-charges">
          <label>
            Total Non Contracted Charges:{" "}
            <span className="small">
              (Submit Invoice to CTSI against this request using Service Level
              EE)
              {/* (Invoice separately Non Contracted ‘N’ Fee code charges) */}
            </span>
          </label>
          <div className="calculation-input">
            <NumericFormat
              thousandSeparator={true}
              className="some"
              inputmode="numeric"
              value={Number(nonContractedCharges)}
              disabled
              decimalSeparator={currencySelected?.currCode !== "JPY" ? "." : ""}
              decimalScale={currencySelected?.currCode !== "JPY" ? "2" : "0"}
              fixedDecimalScale={
                currencySelected?.currCode !== "JPY" ? "true" : "false"
              }
            />
            {/* <input
              type="text"
              disabled
              value={totalCharges["totalNonContractedCharges"]}
            /> */}
          </div>
        </div>
        <div className="total-contracted-charges">
          <label>Total Quotation Charges</label>
          <div className="calculation-input">
            <NumericFormat
              thousandSeparator={true}
              className="some"
              inputmode="numeric"
              value={Number(_totalCharges)}
              disabled
              decimalSeparator={currencySelected?.currCode !== "JPY" ? "." : ""}
              decimalScale={currencySelected?.currCode !== "JPY" ? "2" : "0"}
              fixedDecimalScale={
                currencySelected?.currCode !== "JPY" ? "true" : "false"
              }
            />
            {/* <small>Total_Quotation_Charges</small> */}
            {/* <input
              type="text"
              disabled
              value={totalCharges["totalQuotationCharges"]}
            /> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default InvoiceBidCalculation;